<template lang="pug">
.card.market-card
  .card-header.bg-more-head.collapse-more(
    :id="'heading-twtn-' + id"
    data-toggle='collapse'
    :data-target="'#collapse-twtn-' + id"
    :aria-controls="'collapse-twtn-' + id"
    aria-expanded=true
  )
    .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $tc("m.BT_TWTN", 1) }}
  .collapse.show(
    :aria-labelledby="'heading-twtn-' + id"
    :id="'collapse-twtn-' + id"
  )
    .card-body.p-0
      .market-card-content
        .two-column(v-if="mode == 0 || mode == 1")
          .two-column-title {{ $t("ui.full_time") }}
          .two-column-content
            .two-column-group
              .two-column-odd-area
                .two-column-odd-area-oddtype
                  p.mb-0 {{ $tc("m.BT_H", 1) }}
                .two-column-odd-area-group
                  template(v-if="moreItems['twtno'] && moreItems['twtno']['H'] && moreItems['twtno']['H'][6] && moreItems['twtno']['H'][5] != 0 && moreItems['twtno']['H'][5] != ''")
                    OddsItem(:odds="moreItems['twtno']['H']" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
            .two-column-group
              .two-column-odd-area
                .two-column-odd-area-oddtype
                  p.mb-0 {{ $tc("m.BT_A", 1) }}
                .two-column-odd-area-group
                  template(v-if="moreItems['twtno'] && moreItems['twtno']['A'] && moreItems['twtno']['A'][6] && moreItems['twtno']['A'][5] != 0 && moreItems['twtno']['A'][5] != ''")
                    OddsItem(:odds="moreItems['twtno']['A']" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  }
}
</script>